<template>
  <div class="row">
    <breadcrumb-component
        :moduleTitle="'Service management'"
        :mainTitle="'Network'"
        :subTitle="'Network create'"
    />
    <div class="col-md-12">
      <div class="card card_full_window vm_checkout_page ">
        <div class="card-body">
          <div class="row">
            <template v-if="selectedService?.slug === 'vlan24-cloud'">
              <VlanCloudNetworkForm />
            </template>
            <template v-else>
              <CloudNetworkForm />
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import BreadcrumbComponent from '@/components/shared/BreadcrumbComponent.vue';
import VlanCloudNetworkForm from "@/views/services/cloud_networks/VlanCloudNetworkForm.vue";
import CloudNetworkForm from "@/views/services/cloud_networks/CloudNetworkForm.vue";

export default {
  name: 'CreateCloud-network-form',
  components: {CloudNetworkForm, VlanCloudNetworkForm, BreadcrumbComponent},
  data() {
    return {
      selectedService: null
    }
  },
  computed: {
    ...mapGetters({
      customer: 'auth/getUserInfo',
      services: 'auth/getCustomerServices',
    }),
  },
  watch: {
    customer: {
      handler(newVal, oldVal) {
        if (newVal?.selected_service_id !== oldVal?.selected_service_id) {
          // Perform actions when selected_service_id changes
          const newService = this.services.find((item) => item.id === parseInt(newVal?.selected_service_id));
          if (newService) {
            this.selectedService = newService
          } else {
            console.log('No matching service found');
          }
        }
      },
      deep: true, // Watch for changes in nested properties
      immediate: true, // Optional: Run the watcher immediately on component creation
    },
  },
}
</script>
<style scoped>

</style>
  